import { process } from './process';

export const ai = {
  process,
};
